import styles from './styles.module.scss';

import React from 'react';
import classNames from 'classnames';

interface BackgroundProps {
  photoUrl?: string;
}

const Background: React.FC<BackgroundProps> = ({ photoUrl }) => (
  <>
    {/* Background */}
    <div
      className="z-0 absolute top-0 left-0 w-full h-[635px] bg-primary-200"
      style={{
        backgroundImage: `url(${photoUrl})`,
        backgroundSize: 'cover'
      }}
    />

    {/* Gradient with blur */}
    <div
      className={classNames(
        'z-10 absolute top-0 left-0 w-full h-[735px]',
        styles.gradient
      )}
    />
  </>
);
export default Background;
